import img1 from "./img/image/bri1.jpg";
import img2 from "./img/image/heavybri1.png";
import img3 from "./img/image/bridal3.jpg";
import img4 from "./img/image/madubani1.jpg";
import img5 from "./img/image/madhubani3.jpg";
import img6 from "./img/image/madhubani6.jpg";
import img7 from "./img/image/karwachauth1.jpg";
import img9 from "./img/image/karwachauth2.jpg";
import img8 from "./img/image/karwachauth3.jpg";
import img10 from "./img/image/heavynew2.jpg";
import img11 from "./img/image/heavynew1.jpg";
import img12 from "./img/image/heavynew4.jpg";
import img13 from "./img/image/arabicnew.jpg";
import img14 from "./img/image/arabicnew1.jpg";
import img15 from "./img/image/arabicnew2.jpg";



export const HomePageExplore = [
    {
        tag: "Bridal Mehendi Design",
        courses : [
            {
                heading : "Intricate Floral Pattern",
                description : "A stunning bridal Mehendi design featuring an intricate floral pattern that gracefully winds up the arms and hands. The design showcases delicate flowers, vines, and paisleys, creating a mesmerizing and traditional look. This design is perfect for brides who want a detailed, classic style that exudes elegance and timeless beauty.",
                imageUrl: img1 
            },
            {
                heading : "Peacock and Paisley Fusion",
                description : "This bridal Mehendi design combines the elegance of peacocks with the charm of paisleys. The peacocks, detailed with intricate feathers, are surrounded by paisley motifs and delicate lines, symbolizing grace and beauty. The design covers the hands and extends to the forearms, offering a regal and artistic appeal for the modern bride.",
                imageUrl: img2, 
            },
            {
                heading : "Mandala and Geometric Motifs",
                description : "A contemporary bridal Mehendi design featuring a harmonious blend of mandala and geometric motifs. The mandalas, with their intricate circular patterns, are complemented by crisp geometric shapes, creating a balanced and symmetrical design. This style is ideal for brides seeking a modern, sophisticated look with a touch of traditional artistry.",
                imageUrl: img3
            },
        ]
    },
    {
        tag: "Madhubani Design",
        courses : [
            {
                heading : "Intricate Floral Patterns",
                description : "This Madhubani design features delicate floral motifs intricately arranged to create a mesmerizing visual. The detailed lines and vibrant colors celebrate nature's beauty, with blooming flowers and lush leaves symbolizing prosperity and growth. Perfect for adding an elegant touch to any space.",
                imageUrl: img4 
            },
            {
                heading : "Traditional Folk Art",
                description : "Inspired by ancient Indian folklore, this Madhubani design showcases a harmonious blend of geometric shapes and mythological figures. The bold lines and earthy tones reflect the rich cultural heritage, making it an ideal choice for those who appreciate traditional art forms",
                imageUrl: img5
            },
            {
                heading : "Peacock Motif Elegance",
                description : "This Madhubani design highlights the grace and beauty of the peacock, a symbol of royalty and grace. The intricate detailing of the feathers, combined with a striking color palette, brings out the elegance and charm, making it perfect for adding a regal touch to your decor. ",
                imageUrl: img6 
            },
        ]
    },
    {
        tag: "Karwa Chauth Design",
        courses : [
            {
                heading : "Elegant Traditions",
                description : "Adorn your hands with intricate mehendi designs that capture the essence of Karwa Chauth. From delicate paisleys to traditional motifs, these patterns symbolize the love and devotion celebrated on this auspicious day. Perfect for adding a touch of elegance to your rituals, these designs enhance the beauty of your hands as you prepare for the evening festivities.",
                level : 'Beginner to Advance',
                lessionNumber : 6,
                imageUrl: img7 
            },
            {
                heading : "Modern Glamour",
                description : "Embrace a contemporary twist on Karwa Chauth mehendi with designs that blend tradition with modern flair. Bold lines, geometric patterns, and minimalist elements create a chic and stylish look, perfect for the modern woman. These designs are ideal for those who want to honor tradition while showcasing their unique style.",
                imageUrl: img8 
            },
            {
                heading : " Classic Romance",
                description : "Celebrate the timeless romance of Karwa Chauth with classic mehendi designs that tell a story of love and devotion. Intricate florals, swirling vines, and heart-shaped motifs are the perfect choice for this special day. These designs embody the deep connection between husband and wife, making your celebration even more meaningful.",
                imageUrl: img9 
            },
        ]
    },
    {
        tag: 'Heavy Mehendi Design',
        courses : [
            {
                heading : "Intricate Paisley Patterns",
                description : "This mehendi design features detailed paisley motifs that are intricately woven together to create a stunning visual. The patterns cover the entire hand, from the fingertips to the wrist, with fine lines and shading adding depth and elegance. Ideal for brides or festive occasions, this design reflects traditional artistry with a modern twist, making it perfect for those who want to showcase rich cultural heritage in style.",
                imageUrl: img10 
            },
            {
                heading : "Floral Extravaganza",
                description : "The Floral Extravaganza mehendi design is a blooming garden on your hands. This design is adorned with large, bold floral patterns interspersed with delicate leaves and vines, creating a beautiful and harmonious flow. The dense arrangement of flowers provides a full coverage look, perfect for weddings and special events. This design exudes femininity and grace, making your hands a canvas of nature's beauty.",
                imageUrl: img11
            },
            {
                heading : "Royal Mughal Motifs",
                description : "Inspired by the grandeur of Mughal art, this mehendi design features majestic motifs such as domes, minarets, and arches. The design is characterized by its symmetrical layout and detailed embellishments, reflecting the opulence of the Mughal era. Ideal for brides who want a regal touch to their wedding ensemble, this design is a statement of luxury and timeless elegance, covering the hands in a pattern fit for royalty.",
                imageUrl: img12
            },
        ]
    },
    {
        tag: 'Arabic Mehendi Design',
        courses : [
            {
                heading : "Graceful Vines and Leaves Mehendi",
                description : " This Arabic Mehendi design is a stunning blend of graceful vines and delicate leaves that flow elegantly across the hand. The intricate patterns and curves create a mesmerizing effect, making it perfect for brides and festive occasions. The simplicity and elegance of the design make it a timeless choice.",
                imageUrl: img13
            },
            {
                heading : "Modern Paisley Arabic Mehendi ",
                description : "A contemporary take on the traditional, this Arabic Mehendi design features bold paisley motifs combined with geometric patterns. The design is minimal yet impactful, making it ideal for modern brides or anyone looking for a chic and stylish Mehendi. The balance between tradition and modernity makes it a versatile choice",
                imageUrl: img14
            },
            {
                heading : "Floral Elegance Arabic Mehendi ",
                description : "This design showcases the beauty of Arabic Mehendi with its prominent floral motifs and bold outlines. The flowers are intricately detailed, surrounded by flowing lines that add depth and dimension. Ideal for any special occasion, this design beautifully enhances the hands with its sophisticated floral patterns.",
                imageUrl: img15
            },
        ]
    },
]